import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import classnames from 'classnames';
import './Feedback.scss';
import { IMaskInput } from 'react-imask';

// Встроенный компонент для иконки успеха
const IconCheck = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.1875 5.0625L7.3125 12.9375L3.375 9" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Встроенный компонент для иконки ошибки
const IconError = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#B00020" />
    </svg>
);

const PhoneInput = ({ value, onChange, disabled }) => {
    return (
        <IMaskInput
            mask="+7 (000) 000-00-00"
            value={value}
            unmask={false} // если true — будет возвращать только цифры
            onAccept={(val) => onChange(val)}
            disabled={disabled}
            className="feedback__input form__input"
            placeholder="Номер телефона *"
            required
        />
    );
};


// Встроенный компонент попапа
const Popup = ({ isOpen, setIsOpen, status }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    const overlayClasses = classnames('overlay', {
        overlay_active: isOpen,
    });

    const closePopup = () => setIsOpen(false);

    const content = status === 'success' ? {
        icon: <IconCheck />,
        title: 'Ваша заявка принята!',
        text: 'Мы свяжемся с вами в ближайшее время.',
        buttonText: 'ОК',
        popupClass: 'popup_success'
    } : {
        icon: <IconError />,
        title: 'Произошла ошибка',
        text: 'Пожалуйста, попробуйте отправить заявку снова.',
        buttonText: 'Закрыть',
        popupClass: 'popup_error'
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className={overlayClasses} onClick={closePopup}>
            <div className={`popup ${content.popupClass}`} onClick={(e) => e.stopPropagation()}>
                <div className="popup__info">
                    <div className="popup__icon-container">
                        {content.icon}
                    </div>
                    <h2 className="popup__title text_size_lg text-semi-bold">{content.title}</h2>
                    <p className="popup__text text_size_sm">{content.text}</p>
                    <button className="popup__button" onClick={closePopup}>
                        {content.buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

// Основной компонент формы обратной связи
const Feedback = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [userTheme, setUserTheme] = useState('Тема обращения *');
    const [isThemeMenuVisible, setIsThemeMenuVisible] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupStatus, setPopupStatus] = useState('success');

    const themeInputRef = useRef(null);
    const formRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (themeInputRef.current && !themeInputRef.current.contains(event.target) &&
                !event.target.closest('.theme-block')) {
                setIsThemeMenuVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const themeItems = [
        'Финансовые вопросы и бухгалтерия',
        'Предложение о сотрудничестве',
        'Передать резюме',
        'Обнаружена ошибка'
    ];

    const handleThemeClick = (theme) => {
        setUserTheme(theme);
        setIsThemeMenuVisible(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Чистим телефон от пробелов, скобок и дефисов → формат +77777777777
        const normalizedPhone = phone.replace(/\D/g, ''); // оставляем только цифры
        const formattedPhone = normalizedPhone.startsWith('7')
            ? `+${normalizedPhone}`
            : `+7${normalizedPhone}`; // защита, если юзер введёт без +7

        const payload = {
            channel: 'cifron.kz',
            name: name || null,
            email: email || null,
            phone: formattedPhone || null,
            company: null,
            text: message || null,
        };

        if (userTheme && userTheme !== 'Тема обращения *') {
            payload.text = `Тема: ${userTheme}\n\n${payload.text}`;
        }

        const API_URL = 'https://api.support.alaqan.kz/v1/feedback';
        const API_TOKEN = 'WLQtAyrya9*xc@hGanTXtnHt8scuhfph';

        try {
            await axios.post(API_URL, payload, {
                headers: {
                    'X-Auth-Token': API_TOKEN,
                    'Content-Type': 'application/json',
                },
            });

            setPopupStatus('success');
            setIsPopupOpen(true);

            setName('');
            setEmail('');
            setPhone('');
            setMessage('');
            setUserTheme('Тема обращения *');

        } catch (error) {
            console.error('Submission error:', error);
            setPopupStatus('error');
            setIsPopupOpen(true);

        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <section className="feedback" id="feedback">
                <div className="container">
                    <h2 className="title title_block">
                        Давайте поговорим
                    </h2>
                    <h3 className="subtitle">
                        Мы ответим вам в течении 1 рабочего дня
                    </h3>
                    <form className="form" onSubmit={handleSubmit} ref={formRef}>
                        <div
                            className={`feedback__input theme-input form__input ${isSubmitting ? 'disabled' : ''}`}
                            id="theme-input"
                            onClick={() => setIsThemeMenuVisible(!isThemeMenuVisible)}
                            ref={themeInputRef}
                        >
                            {userTheme}
                            <div className={`theme-block ${isThemeMenuVisible ? '' : 'hide'}`}>
                                {themeItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className="theme-item"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleThemeClick(item);
                                        }}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <input
                            id="feedback-name"
                            name="feedback-name"
                            className={`feedback__input form__input ${isSubmitting ? 'disabled' : ''}`}
                            type="text"
                            placeholder="Имя *"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={isSubmitting}
                        />
                        <input
                            id="feedback-email"
                            name="feedback-email"
                            className={`feedback__input form__input ${isSubmitting ? 'disabled' : ''}`}
                            type="email"
                            placeholder="Эл.почта *"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isSubmitting}
                        />
                        <PhoneInput
                            value={phone}
                            onChange={setPhone}
                            disabled={isSubmitting}
                        />
                        <textarea
                            className={`feedback__text form__input ${isSubmitting ? 'disabled' : ''}`}
                            name="feedback__text"
                            id="feedback-text"
                            placeholder="Сообщение *"
                            required
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            disabled={isSubmitting}
                        ></textarea>
                        <button
                            className={`feedback__btn ${isSubmitting ? 'disabled' : ''}`}
                            id="feedback__btn"
                            type="submit"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Отправка...' : 'Отправить сообщение'}
                        </button>
                    </form>
                    <footer>
                        ©2025 – Developing company «CifrON», Kazakhstan — info@cifron.kz
                    </footer>
                </div>
            </section>

            <Popup
                isOpen={isPopupOpen}
                setIsOpen={setIsPopupOpen}
                status={popupStatus}
            />
        </>
    );
};

export default Feedback;
